import { INgayNghi } from "../../../models/response/category/INgayNghi";
import {
    eNgayNghiActionTypeIds,
    INgayNghiCloseEditModal,
    INgayNghiDeleteError,
    INgayNghiDeleteStart,
    INgayNghiDeleteSuccess,
    INgayNghiLoadError,
    INgayNghiLoadStart,
    INgayNghiLoadSuccess,
    INgayNghiSaveError,
    INgayNghiSaveStart,
    INgayNghiSaveSuccess,
    INgayNghiShowEditModal,
} from "../../action-types/danh-muc/INgayNghiActionTypes";
import { BaseAction } from "../IBaseActionResult";

export const ngayNghiActions = {
    LOAD_START: (_payload: undefined): INgayNghiLoadStart => BaseAction(undefined, eNgayNghiActionTypeIds.LOAD_START),
    LOAD_SUCCESS: (payload: INgayNghi[]): INgayNghiLoadSuccess => BaseAction(payload, eNgayNghiActionTypeIds.LOAD_SUCCESS),
    LOAD_ERROR: (payload: string): INgayNghiLoadError => BaseAction(payload, eNgayNghiActionTypeIds.LOAD_ERROR),

    SAVE_START: (payload: INgayNghi): INgayNghiSaveStart => BaseAction(payload, eNgayNghiActionTypeIds.SAVE_START),
    SAVE_SUCCESS: (_payload: undefined): INgayNghiSaveSuccess => BaseAction(undefined, eNgayNghiActionTypeIds.SAVE_SUCCESS),
    SAVE_ERROR: (payload: string): INgayNghiSaveError => BaseAction(payload, eNgayNghiActionTypeIds.SAVE_ERROR),

    DELETE_START: (payload: number): INgayNghiDeleteStart => BaseAction(payload, eNgayNghiActionTypeIds.DELETE_START),
    DELETE_SUCCESS: (_payload: undefined): INgayNghiDeleteSuccess => BaseAction(undefined, eNgayNghiActionTypeIds.DELETE_SUCCESS),
    DELETE_ERROR: (payload: string): INgayNghiDeleteError => BaseAction(payload, eNgayNghiActionTypeIds.DELETE_ERROR),

    SHOW_EDIT_MODAL: (payload: INgayNghi | undefined): INgayNghiShowEditModal => BaseAction(payload, eNgayNghiActionTypeIds.SHOW_EDIT_MODAL),
    CLOSE_EDIT_MODAL: (_payload: undefined): INgayNghiCloseEditModal => BaseAction(undefined, eNgayNghiActionTypeIds.CLOSE_EDIT_MODAL),
};
